import { css } from "lit";
// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** Content feedback. */

.content-feedback {
  padding: 0;
  margin: 0;
  margin-bottom: 0.25rem;

  border: none;
}

.content-feedback  > label {
    display: block;
    margin-bottom: 0.25rem;
  }

.content-feedback .thank-you {
    display: block;
    margin-bottom: calc(2.75rem + 2px);
  }

.content-feedback mdn-button {
    /* Ensure both buttons have same size. */
    flex: 1;
    min-width: 0;
  }

:is(.content-feedback mdn-button):not(:hover) {
      --csstools-light-dark-toggle--0: var(--csstools-color-scheme--light) #313131;
      --button-bg: var(
        --color-background-secondary,
        var(--csstools-light-dark-toggle--0, #f9f9f9)
      );
      --csstools-light-dark-toggle--1: var(--csstools-color-scheme--light) #ffffff;
      --button-color: var(--color-text-primary, var(--csstools-light-dark-toggle--1, #1b1b1b));
    }

@supports (color: light-dark(red, red)) {
:is(.content-feedback mdn-button):not(:hover) {
      --button-bg: var(
        --color-background-secondary,
        light-dark(#f9f9f9, #313131)
      );
      --button-color: var(--color-text-primary, light-dark(#1b1b1b, #ffffff));
    }
}

@supports not (color: light-dark(tan, tan)) {

:is(.content-feedback mdn-button):not(:hover) * {
      --csstools-light-dark-toggle--0: var(--csstools-color-scheme--light) #313131;
      --button-bg: var(
        --color-background-secondary,
        var(--csstools-light-dark-toggle--0, #f9f9f9)
      );
      --csstools-light-dark-toggle--1: var(--csstools-color-scheme--light) #ffffff;
      --button-color: var(--color-text-primary, var(--csstools-light-dark-toggle--1, #1b1b1b));
  }
}

[data-vote="yes"]:is(.content-feedback mdn-button) {
      --csstools-light-dark-toggle--2: var(--csstools-color-scheme--light) #00d061;
      --button-bg-hover: var(
        --color-text-primary-green,
        var(--csstools-light-dark-toggle--2, #007936)
      );
    }

@supports (color: light-dark(red, red)) {
[data-vote="yes"]:is(.content-feedback mdn-button) {
      --button-bg-hover: var(
        --color-text-primary-green,
        light-dark(#007936, #00d061)
      );
    }
}

@supports not (color: light-dark(tan, tan)) {

[data-vote="yes"]:is(.content-feedback mdn-button) * {
      --csstools-light-dark-toggle--2: var(--csstools-color-scheme--light) #00d061;
      --button-bg-hover: var(
        --color-text-primary-green,
        var(--csstools-light-dark-toggle--2, #007936)
      );
  }
}

[data-vote="no"]:is(.content-feedback mdn-button) {
      --csstools-light-dark-toggle--3: var(--csstools-color-scheme--light) #ff97a0;
      --button-bg-hover: var(
        --color-text-primary-red,
        var(--csstools-light-dark-toggle--3, #d30038)
      );
    }

@supports (color: light-dark(red, red)) {
[data-vote="no"]:is(.content-feedback mdn-button) {
      --button-bg-hover: var(
        --color-text-primary-red,
        light-dark(#d30038, #ff97a0)
      );
    }
}

@supports not (color: light-dark(tan, tan)) {

[data-vote="no"]:is(.content-feedback mdn-button) * {
      --csstools-light-dark-toggle--3: var(--csstools-color-scheme--light) #ff97a0;
      --button-bg-hover: var(
        --color-text-primary-red,
        var(--csstools-light-dark-toggle--3, #d30038)
      );
  }
}

.content-feedback--buttons {
  /* Ensure both buttons take minimal width. */
  display: inline-flex;
  gap: 0.75rem;
  margin: 0.25rem 0;
}

.content-feedback--radios {
  display: flex;

  gap: 0.25rem;
  align-items: center;

  margin: 0.25rem 0;
}
`, "",{"version":3,"sources":["webpack://./components/content-feedback/index.css"],"names":[],"mappings":"AAAA,uBAAuB;;AAEvB;EACE,UAAU;EACV,SAAS;EACT,sBAAsB;;EAEtB,YAAY;AAuCd;;AArCE;IACE,cAAc;IACd,sBAAsB;EACxB;;AAEA;IACE,cAAc;IACd,kCAAkC;EACpC;;AAEA;IACE,wCAAwC;IACxC,OAAO;IACP,YAAY;EAuBd;;AArBE;MACE,4EAGC;MAHD;;;OAGC;MACD,4EAAuE;MAAvE,wFAAuE;IACzE;;AANA;AAAA;MACE;;;OAGC;MACD,uEAAuE;IACzE;AAAA;;AALE;;AAAA;MAAA,4EAGC;MAHD;;;OAGC;MACD,4EAAuE;MAAvE;EADC;AAAA;;AAIH;MACE,4EAGC;MAHD;;;OAGC;IACH;;AALA;AAAA;MACE;;;OAGC;IACH;AAAA;;AAJE;;AAAA;MAAA,4EAGC;MAHD;;;;EAGC;AAAA;;AAGH;MACE,4EAGC;MAHD;;;OAGC;IACH;;AALA;AAAA;MACE;;;OAGC;IACH;AAAA;;AAJE;;AAAA;MAAA,4EAGC;MAHD;;;;EAGC;AAAA;;AAKP;EACE,4CAA4C;EAC5C,oBAAoB;EACpB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;;EAEb,YAAY;EACZ,mBAAmB;;EAEnB,iBAAiB;AACnB","sourcesContent":["/** Content feedback. */\n\n.content-feedback {\n  padding: 0;\n  margin: 0;\n  margin-bottom: 0.25rem;\n\n  border: none;\n\n  > label {\n    display: block;\n    margin-bottom: 0.25rem;\n  }\n\n  .thank-you {\n    display: block;\n    margin-bottom: calc(2.75rem + 2px);\n  }\n\n  mdn-button {\n    /* Ensure both buttons have same size. */\n    flex: 1;\n    min-width: 0;\n\n    &:not(:hover) {\n      --button-bg: var(\n        --color-background-secondary,\n        light-dark(#f9f9f9, #313131)\n      );\n      --button-color: var(--color-text-primary, light-dark(#1b1b1b, #ffffff));\n    }\n\n    &[data-vote=\"yes\"] {\n      --button-bg-hover: var(\n        --color-text-primary-green,\n        light-dark(#007936, #00d061)\n      );\n    }\n\n    &[data-vote=\"no\"] {\n      --button-bg-hover: var(\n        --color-text-primary-red,\n        light-dark(#d30038, #ff97a0)\n      );\n    }\n  }\n}\n\n.content-feedback--buttons {\n  /* Ensure both buttons take minimal width. */\n  display: inline-flex;\n  gap: 0.75rem;\n  margin: 0.25rem 0;\n}\n\n.content-feedback--radios {\n  display: flex;\n\n  gap: 0.25rem;\n  align-items: center;\n\n  margin: 0.25rem 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default css([___CSS_LOADER_EXPORT___.toString()]);
